{
  "minimumCatchPointSkill": 0.64,
  "minimumAttemptCatchPointSkill": 0.48,
  "minimumInterceptionCatchPointSkill": 0.72,
  "minimumCatchQuality": 0.58,
  "minimumInterceptionCatchQuality": 0.64,
  "minimumInterceptionReachYards": 0.7,
  "maximumInterceptionReachYards": 2.15,
  "minimumInterceptionLongitudinalReachYards": 0.45,
  "maximumPlannedYacYards": 3,
  "minimumReachYards": 0.58,
  "maximumReachYards": 1.72,
  "minimumForwardReachYards": 0.48,
  "minimumAttemptReachYards": 0.52,
  "maximumAttemptReachYards": 3.2,
  "minimumAttemptForwardReachYards": 0.28,
  "baseTransferFrames": 18,
  "maximumTransferFrames": 22,
  "launchEndProgress": 0.22,
  "contactProgress": 0.58,
  "landingProgress": 0.86,
  "maximumLaunchTravelYards": 1.42,
  "minimumLaunchTravelYards": 0.68,
  "landingSkidYards": 0.38,
  "maximumVerticalLiftYards": 1.08,
  "verticalLiftApexProgress": 0.58,
  "groundRecoveryHoldFrames": 50,
  "groundRecoveryRiseFrames": 13,
  "heroMoment": {
    "minimumAirYards": 12,
    "completionChance": 0.88,
    "attemptChance": 0.3,
    "interceptionChance": 0.92,
    "leadInFrames": 7,
    "followThroughFrames": 9,
    "receptionForwardDiveYards": 1.25,
    "presentationLiftPixels": 7,
    "slowMotionRate": 0.38,
    "zoomScale": 1.44,
    "soundVolume": 0.4
  }
}
